import { FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";
import * as Yup from "yup";

import {
  TitreDiplomeCertificationApi,
  TitreDiplomeCertificationEditDto,
  TitreDiplomeCertificationEditDtoFromJSON
} from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { FGWalterCheckboxInput, SmallFormGenerator } from "../../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

export interface ITitreDiplomeCertificationDetailPageProps {
  editMode: boolean;
  idTitreDiplomeCertification: number;
}

export const TitreDiplomeCertificationDetailPage: React.FunctionComponent<ITitreDiplomeCertificationDetailPageProps> = ({
  idTitreDiplomeCertification,
  editMode
}) => {
  const { t } = useTl();
  const api = useApiService(TitreDiplomeCertificationApi);
  const history = useHistory();

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      description: Yup.string().required(t(ETLCodes.Required))
    });
  }, [t]);

  const { data, loading, deleteItem, deleting, saveItem, saving } = useCrudApi<TitreDiplomeCertificationEditDto>({
    getApiFn: () =>
      +idTitreDiplomeCertification <= 0
        ? TitreDiplomeCertificationEditDtoFromJSON({ idTitreDiplomeCertification: 0 })
        : api.titreDiplomeCertificationGetTitreDiplomeCertification({ id: +idTitreDiplomeCertification }),
    saveApiFn: d => api.titreDiplomeCertificationSaveTitreDiplomeCertification({ TitreDiplomeCertificationEditDto: d }),
    onSavedRoute: d => `${ERoutes.titreDiplomeCertification}/${d.idtitreDiplomeCertification}/detail/edit`,
    deleteApiFn: d =>
      api.titreDiplomeCertificationDeleteTitreDiplomeCertification({ id: d.idtitreDiplomeCertification }),
    onDeletedRoute: () => ERoutes.diplome
  });

  return (
    <SmallFormGenerator
      initialValues={data}
      onSubmit={saveItem}
      editMode={editMode}
      validationSchema={FormSchema}
      loading={loading}
      onCancel={() => history.push(ERoutes.diplome)}
      onDelete={deleteItem}
      showDeleteButton={+idTitreDiplomeCertification > 0}
      saving={saving}
      deleting={deleting}
    >
      <FieldGroup>
        <FGTextInput name="description" label={t(ETLCodes.Libelle)} maxLength={75} />
        <FGWalterCheckboxInput name="actif" label={t(ETLCodes.Actif)} />
      </FieldGroup>
    </SmallFormGenerator>
  );
};
